class Validation {

    validate(type, value, validateIfNot, validateChild) {
        let regex = null;

        switch (type) {
            case "email":
                regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                break;

            case "password_repeat":
                let valueToCompare = document.querySelector("input[type='password'][name='password']").value;
                return value === valueToCompare && valueToCompare.length > 0;

            case "username_email":
                switch (typeof value) {
                    case "number":
                        return value > 0;

                    case "string":
                        return value.length > 0;
                }
                break;

            case "password":
                if (value.length) {
                    return value.length >= 4 && value.length < 30;
                }
                return false;

            case "username":
                if (value.length) {
                    return value.length >= 2 && value.length <= 25;
                }
                return false;

            case "required":
                if (value.length) {
                    return value.length > 0;
                }
                return false;

            case "alphanumeric":
                if (value.length < 1) {
                    return false;
                }
                regex = /^[a-z0-9]+$/i;
                break;

            case "required_if":
                if (validateChild.value.trim().length > 0 && value.trim().length === 0) {
                    return false;
                }
                break;

            case "required_if_not":
                if (validateChild) {
                    if (!validateChild && (!validateIfNot || !validateIfNot.value || (validateIfNot.type === "checkbox" && !validateIfNot.checked))) {
                        return false;
                    }
                } else {
                    if (!value && (!validateIfNot || !validateIfNot.value || (validateIfNot.type === "checkbox" && !validateIfNot.checked))) {
                        return false;
                    }
                }
                break;
        }

        if (regex) {
            return regex.test(value);
        } else {
            return true;
        }
    }
}